import React from 'react';

const HOUSE_IMG = `${process.env.PUBLIC_URL}/assets/markers/seller/Home.png`;

interface PreviewCardProps {
  address: string;
  area?: string;
  size?: string;
  rooms?: string;
  roomsSuffix?: string;
  // Reserve the rooms slot on the facts line even before a count is chosen,
  // showing a placeholder so the rooms step reads `size · •••`.
  roomsPlaceholder?: boolean;
}

// Beige summary card that "grows" as the user advances through the wizard:
// first just the address, then the size, then size + rooms. Mirrors the
// building-preview card in the Figma flow.
const PreviewCard = ({ address, area, size, rooms, roomsSuffix, roomsPlaceholder }: PreviewCardProps) => {
  const showRoomsSlot = !!rooms || !!roomsPlaceholder;
  return (
    <div className="amp-preview-band">
      <div className="amp-preview-card">
        <div className="amp-preview-card__visual">
          <img src={HOUSE_IMG} alt="" aria-hidden="true" className="amp-preview-card__house" />
        </div>
        <div className="amp-preview-card__content">
          <p className="amp-preview-card__address">
            {address}
            {area ? `, ${area}` : ''}
          </p>

          <p className="amp-preview-card__facts">
            {size && <span className="amp-preview-card__size">{size}m&sup2;</span>}
            {size && showRoomsSlot && <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
              <circle cx="2.10547" cy="2.10547" r="2.10547" fill="#C7CED1" />
            </svg>}
            {((showRoomsSlot && !rooms) || (!size)) ? (
              <span className="amp-preview-card__more amp-preview-card__more--accent" aria-hidden="true">...</span>
            ) : (
              <span className="amp-preview-card__rooms">
                {rooms}
                {roomsSuffix ? ` ${roomsSuffix}` : ''}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PreviewCard;
